module.exports = __webpack_public_path__ + "assets/img/integral.f9941f92.svg";